import * as types from '@/external/store/mutation-types';

// initial state
const state = {
  currentStep: 0,
  username: '',
  email: '',
  password: '',
  passwordConfirm: ''
};

// mutations
const mutations = {
  [types.SET_USERNAME] (state, username) {
    state.username = username;
  },
  [types.SET_EMAIL] (state, email) {
    state.email = email;
  },
  [types.SET_PASSWORD] (state, password) {
    state.password = password;
  },
  [types.SET_PASSWORD_CONFIRM] (state, password) {
    state.passwordConfirm = password;
  },
  [types.UPDATE_STEP] (state, step) {
    state.currentStep = step;
  }
};

const actions = {
  setUsername: ({ commit }, username) => {
    commit(types.SET_USERNAME, username)
  },
  setEmail: ({ commit }, email) => {
    commit(types.SET_EMAIL, email)
  },
  setPassword: ({ commit }, password) => {
    commit(types.SET_PASSWORD, password)
  },
  setPasswordConfirm: ({ commit }, password) => {
    commit(types.SET_PASSWORD_CONFIRM, password)
  },
  updateCurrentStep: ({ commit }, step) => {
    commit(types.UPDATE_STEP, step)
  }
};

const getters = {
  register (state) {
    return state;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/external/store/modules/register.js